import type { DashboardOverview } from '@/lib/types';
import StatCard from './StatCard';
import SimpleBarChart from './SimpleBarChart';
import RecentActivity from './RecentActivity';
import QuickActions from './QuickActions';

interface AdminDashboardProps {
  data: DashboardOverview;
}

export default function AdminDashboard({ data }: AdminDashboardProps) {
  const { stats, chart, recent_activity, users_by_role } = data;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <StatCard label="Students" value={stats.students ?? 0} accent="blue" />
        <StatCard label="Tutors" value={stats.tutors ?? 0} accent="teal" />
        <StatCard label="Admins" value={stats.admins ?? 0} accent="violet" />
        <StatCard label="Courses" value={stats.courses ?? 0} accent="amber" />
        <StatCard label="Enrollments" value={stats.enrollments ?? 0} accent="rose" />
        <StatCard label="Exams" value={stats.exams ?? 0} accent="slate" />
      </div>

      <QuickActions
        actions={[
          { label: 'Courses', to: '/courses' },
          { label: 'Exams', to: '/exams', variant: 'secondary' },
        ]}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <SimpleBarChart
          title={chart.title}
          items={chart.items}
          emptyMessage="No course enrollments yet."
        />
        <div className="space-y-6">
          <SimpleBarChart
            title="Users by role"
            items={users_by_role ?? []}
            emptyMessage="No users found."
          />
          <RecentActivity
            items={recent_activity}
            emptyMessage="Platform enrollments will appear here."
          />
        </div>
      </div>
    </div>
  );
}
